import {colors} from '@bettermarks/bm-ui-components';
import React from 'react';

export const DragIcon: React.FC<React.SVGAttributes<SVGElement>> = ({fill}) => (
  <svg
    width='28'
    height='29'
    viewBox='0 0 28 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.8684 4.9281L13.9403 0L9.01221 4.9281L9.79622 5.71212L13.8283 1.68003L17.8604 5.71212L18.8684 4.9281ZM27.3805 14.5591H0.5V13.4391H27.3805V14.5591ZM27.3805 17.9192H0.5V19.0392H27.3805V17.9192ZM27.3805 8.95898H0.5V10.079H27.3805V8.95898ZM17.9727 22.2891L18.7567 23.0731L13.8286 28.0012L9.12451 23.0731L9.90853 22.2891L13.9406 26.3211L17.9727 22.2891Z'
      fill={fill || colors.cBlue700}
    />
  </svg>
);
